import axios from "axios"

const controller = "/transferenciaItems"

const TransferenciaItemsService = {
    buscar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            transferencia_items
        })
        return data
    },
    buscarDetallexOrden: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/buscarDetallexOrden`, {
            transferencia_items
        })
        return data
    },
    registrar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            transferencia_items
        })
        return data
    },
    eliminar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/eliminar`, {
            transferencia_items
        })
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    ingresar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/ingresar`, {
            transferencia_items
        })
        return data
    },
    historialTransferenciasxItem: async (producto_almacen) => {
        const { data } = await axios.post(`${controller}/historialTransferenciasxItem`, {
            producto_almacen
        })
        return data
    },


}

export default TransferenciaItemsService